import React from 'react';
import { useSelector } from 'react-redux';
import { EarlyAccessCounterBanner } from 'shared/components/EarlyAccessCounterBanner';
import { selectEarlyAccessCounterData } from 'shared/selectors/earlyAccessCounter';

import * as styles from './EarlyAccessCounterBannerContainer.css';

export function EarlyAccessCounterBannerContainer() {
  const data = useSelector(selectEarlyAccessCounterData);

  if (!data) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <EarlyAccessCounterBanner text={data.text} />
    </div>
  );
}
